// AUTO-GENERATED — DO NOT EDIT BY HAND.
// Source of truth: aol_schemas.feedback (aol-us-shared). Regenerate with
// `./devops build types` (emitter: aol_schemas/export_feedback.py).

export const FeedbackScope = {
  MESSAGE: 'message',
  CONVERSATION: 'conversation',
} as const;
export type FeedbackScope = (typeof FeedbackScope)[keyof typeof FeedbackScope];

export const FeedbackSentiment = {
  UP: 'up',
  DOWN: 'down',
} as const;
export type FeedbackSentiment = (typeof FeedbackSentiment)[keyof typeof FeedbackSentiment];

export const FeedbackSource = {
  IDLE: 'idle',
  END_CHAT: 'end_chat',
  HANDOFF_WRAP: 'handoff_wrap',
  MENU: 'menu',
  MESSAGE_ROW: 'message_row',
} as const;
export type FeedbackSource = (typeof FeedbackSource)[keyof typeof FeedbackSource];

export const SupportRequestType = {
  MESSAGE: 'message',
  CALLBACK: 'callback',
} as const;
export type SupportRequestType = (typeof SupportRequestType)[keyof typeof SupportRequestType];

export const SupportRequestStatus = {
  NEW: 'new',
  PUSHED: 'pushed',
  FAILED: 'failed',
} as const;
export type SupportRequestStatus = (typeof SupportRequestStatus)[keyof typeof SupportRequestStatus];

export const CallbackWindow = {
  ANYTIME: 'anytime',
  MORNING: 'morning',
  AFTERNOON: 'afternoon',
  EVENING: 'evening',
} as const;
export type CallbackWindow = (typeof CallbackWindow)[keyof typeof CallbackWindow];
